import React, { RefObject } from 'react';
import { useAppActions } from '../../../../overmind';
import { NotificationPriority, NotificationType } from '../../../../notifications/notifications.models';
import { IFreemiumBulkActionsMenuProps } from './freemium-bulk-actions-menu.models';
import { Button, MenuList, MenuTriggerContainer, MenuItem, ChevronIcon } from '@keplerco/core';

export function BulkActionsMenu(props: IFreemiumBulkActionsMenuProps): JSX.Element {
  const actions = useAppActions();

  function generateBulkActions(): MenuItem[] {
    const data = props.data;
    if (!data) return [];

    return [
      {
        label: 'Archive Selected',
        onClick: async () => { actions.displayPaywall('send invites'); },
        disabled: true,
      },
      {
        label: 'Send activation invitation(s)',
        onClick: () => { actions.displayPaywall('send invites'); },
        disabled: true,
      },
      {
        label: 'Send activation reminder(s)',
        onClick: () => actions.displayPaywall('send invites'),
        disabled: true,
      },
    ];
  }

  return (
    <MenuList items={generateBulkActions()}>
      {({ triggerRef, onOpenHandler }) => (
        <MenuTriggerContainer
          ref={triggerRef as RefObject<HTMLDivElement>}
          onClick={() => {
            if (props.selectedRows.length > 0) {
              onOpenHandler();
            } else {
              actions.addNotification({
                title: 'No people selected',
                message: `Bulk actions require that you select at least one item in the list.`,
                active: true,
                type: NotificationType.Error,
                priority: NotificationPriority.Toast,
                id: `activation_error_${Date.now()}`,
              });
            }
          }}
        >
          <Button disabled={props.selectedRows.length < 1} type="button" square theme="dark">
            <div style={{ display: 'flex', gap: 15, alignItems: 'center' }}>
              Bulk Actions
              <ChevronIcon rotation={2} tone="primary" size={15} />
            </div>
          </Button>
        </MenuTriggerContainer>
      )}
    </MenuList>
  );
}
